import { initAbTesting as initGrowthbook } from "@solvari/common-fe/ab-testing";

async function initAbTesting(features?: () => void) {
  await initGrowthbook();
  features?.();
}

export { initAbTesting };
